var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.62,36.84h7.22c1.57-3,2.47-6.34,2.63-9.73H40.9C40.82,30.5,40.39,33.76,39.62,36.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.87,24.1h8.55c-0.25-3.15-1.12-6.15-2.58-8.95h-7.22C40.33,17.98,40.75,20.98,40.87,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,36.84h9.04c0.81-3.01,1.27-6.34,1.35-9.73H27.5V36.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,49.3c3.2-0.82,6.13-4.24,8.08-9.46H27.5V49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,27.1H14.1c0.08,3.39,0.55,6.72,1.36,9.73h9.04V27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.98,39.84h-6.24c-1.11,3.24-2.59,6-4.33,8.1C38.61,46.32,42.29,43.51,44.98,39.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,49.3v-9.46h-8.08C18.37,45.06,21.3,48.48,24.5,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.6,47.94c-1.74-2.1-3.22-4.86-4.33-8.1H7.02C9.71,43.51,13.4,46.32,17.6,47.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.6,4.06c-4.2,1.62-7.88,4.42-10.57,8.09h6.24C14.38,8.92,15.86,6.16,17.6,4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.58,24.1h8.55c0.12-3.12,0.54-6.12,1.25-8.95H5.16C3.7,17.95,2.83,20.95,2.58,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.16,36.84h7.22c-0.77-3.08-1.2-6.34-1.28-9.73H2.53C2.69,30.5,3.59,33.83,5.16,36.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,24.1h10.37c-0.13-3.12-0.59-6.18-1.33-8.95H27.5V24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,2.7c-3.2,0.82-6.12,4.23-8.08,9.45h8.08V2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.97,12.15C42.29,8.48,38.6,5.67,34.4,4.06c1.74,2.1,3.22,4.86,4.33,8.09H44.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,2.7v9.46h8.08C33.62,6.93,30.7,3.52,27.5,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.5,15.15h-9.04c-0.75,2.77-1.2,5.83-1.33,8.95H24.5V15.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.f588bb94bb18ae4ec8a9a8c324105a24.svg";
export { ForwardRef as ReactComponent };